export function localDevPortSuffix(_origin?: string): string {
  if (typeof window !== "undefined" && window.location.port) {
    return `:${window.location.port}`;
  }
  return "";
}
